module.exports = __webpack_public_path__ + "img/horizontal_3_6_1.9a373bdc.png";